import { useEffect, useState } from 'react'
import Accordion from '../campusLife/accordion'
import Heading from '../heading'
import {
  FaArrowRight,
  FaFacebookF,
  FaInstagram,
  FaYoutube
} from 'react-icons/fa6'
import { PropTypes } from 'prop-types'
import { retrunAssets } from '../../utils/getAssets'
import { DecodeHtml } from '../../utils/decodeHtml'
const Welcome = ({ internationalOffice }) => {
  const data = {
    title: internationalOffice?.welcomeTitle,
    img:
      internationalOffice?.welcomeImage != null
        ? retrunAssets(internationalOffice?.welcomeImage[0]?.url)
        : ''
  }
  const InternationalStudentServicesISS =
    internationalOffice?.InternationalStudentServicesISS

  const submissionInstruction = internationalOffice?.submissionInstruction
  const documentPICDetails = internationalOffice?.documentPICDetails
    ?.split('\n')
    .map((item, index) => (
      <p
        key={index}
        className='w-auto  text-sky-950  text-base font-bold leading-normal'
      >
        {item}
      </p>
    ))
  const belowPIC = {
    label: internationalOffice?.belowPIC?.items[0]?.content?.properties?.label,
    link: internationalOffice?.belowPIC?.items[0]?.content?.properties?.link
  }
  const connectingTheGlobeDescription = DecodeHtml({
    html: internationalOffice?.connectingTheGlobeDescription?.markup
  })
  const facebookURL = internationalOffice?.facebookURL
  const instagramURL = internationalOffice?.instagramPageURL
  const youtubeURL = internationalOffice?.youTubePageURL

  const [accordion, setAccordion] = useState([])

  useEffect(() => {
    setAccordion(
      internationalOffice?.accordions?.items?.map((accordionData, index) => {
        accordionData = accordionData?.content?.properties
        return {
          open: index === 0 ? true : false,
          question: accordionData?.label,
          answer: accordionData?.accordionContent ? (
            <p className='w-auto lg:px-4 text-justify text-sky-950 text-base font-normal whitespace-pre-line leading-normal'>
              {DecodeHtml({ html: accordionData?.accordionContent?.markup })}
            </p>
          ) : (
            <div className='flex flex-col'>
              {accordionData?.accordionDownloadButtons?.items.map(
                (item, index) => {
                  item = item?.content?.properties
                  return (
                    <a
                      href={
                        item?.buttonDownload != null &&
                        retrunAssets(item?.buttonDownload[0]?.url)
                      }
                      target='_blank'
                      rel='noreferrer'
                      key={index}
                      className='text-sky-600 text-xl font-semibold underline underline-offset-4 cursor-pointer'
                    >
                      {item?.label}
                    </a>
                  )
                }
              )}
            </div>
          )
        }
      })
    )
  }, [internationalOffice?.accordions?.items])

  return (
    <div className='flex justify-center p-4 md:py-8 w-full'>
      <div className='flex flex-col gap-5 lg:px-16  '>
        <Heading name='International Office' />
        <div className='w-full grid grid-cols-1 place-items-center  lg:place-items-start lg:grid-cols-2 gap-10'>
          <div className='w-full flex flex-col gap-4'>
            <h1 className='w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight'>
              {data?.title}
            </h1>
            <div
              className='w-full  h-[40rem] bg-center  bg-cover bg-no-repeat'
              style={{ backgroundImage: `url('${data?.img}')` }}
            ></div>
          </div>
          <div className='w-full flex flex-col gap-8'>
            <h1 className='text-2xl text-slate-900 font-semibold  2xl:text-3xl '>
              {InternationalStudentServicesISS}
            </h1>
            <Accordion accordion={accordion} setAccordion={setAccordion} />
            <p className='w-auto  text-justify text-sky-950 text-opacity-70 text-base font-normal leading-normal'>
              {submissionInstruction}
            </p>
            <div className='flex flex-col'>{documentPICDetails}</div>
            {belowPIC?.label && belowPIC?.link && (
              <a
                href={belowPIC?.link}
                target='_blank'
                rel='noreferrer'
                className='px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 w-fit flex'
              >
                <span className='text-white text-base font-bold capitalize flex items-center gap-3'>
                  {belowPIC?.label} <FaArrowRight />
                </span>
              </a>
            )}
          </div>
        </div>
        <div className='flex flex-col gap-5 my-8'>
          <h1 className='text-2xl text-slate-900 font-semibold  2xl:text-3xl '>
            Connecting the Globe: UNITEN International Office (IO) - Your
            Gateway to a Rich Academic and Social Experience
          </h1>
          <p className='whitespace-pre-line w-full'>
            {connectingTheGlobeDescription}
          </p>
        </div>
        <div className='py-2 flex gap-5 items-center'>
          {facebookURL && (
            <a
              href={facebookURL}
              target='_blank'
              rel='noreferrer'
              className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] text-[#003acbb7] bg-opacity-65 '
            >
              <FaFacebookF />
            </a>
          )}
          {instagramURL && (
            <a
              href={instagramURL}
              target='_blank'
              rel='noreferrer'
              className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] text-[#003acbb7] bg-opacity-65 '
            >
              <FaInstagram />
            </a>
          )}

          {youtubeURL && (
            <a
              href={youtubeURL}
              target='_blank'
              rel='noreferrer'
              className='flex items-center justify-center w-7 h-7 2xl:w-10 2xl:h-10 rounded-full bg-[#0039CB1A] text-[#003acbb7] bg-opacity-65 '
            >
              <FaYoutube />
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
Welcome.propTypes = {
  internationalOffice: PropTypes.any
}
export default Welcome
